module.exports = __webpack_public_path__ + "static/img/audio-load.8abe50e5.png";